import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { authService } from "../services/auth";

// Context oluştur
const LocationContext = createContext();

// Context Provider Bileşeni
export const LocationProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isLoadingLocation, setIsLoadingLocation] = useState(true);

  // Başlangıç konumunu yükle (localStorage veya kullanıcı varsayılanı)
  useEffect(() => {
    setIsLoadingLocation(true);
    let locationData = null;
    try {
      const savedLocation = localStorage.getItem("selectedLocation");
      if (savedLocation) {
        locationData = JSON.parse(savedLocation);
        console.log(
          "LocationContext: localStorage dan konum yüklendi",
          locationData
        );
      }
    } catch (e) {
      console.error("LocalStorage dan konum okunurken hata:", e);
      localStorage.removeItem("selectedLocation");
    }

    // localStorage'da yoksa giriş yapmış kullanıcıyı kontrol et
    if (!locationData) {
      const currentUser = authService.getCurrentUser();
      if (currentUser && currentUser.city_id && currentUser.district_id) {
        // Kullanıcının ana adres bilgilerini alalım (API'de varsa)
        // Şimdilik sadece ID ve isimleri alıyoruz
        locationData = {
          addressId: currentUser.default_address_id || null, // Varsayılan adres ID'si (varsa)
          cityId: currentUser.city_id,
          districtId: currentUser.district_id,
          cityName: currentUser.city_name,
          districtName: currentUser.district_name,
          // title ve fullAddress burada olmayabilir, kullanıcı adres listesinden seçince gelir
        };
        console.log(
          "LocationContext: Kullanıcı varsayılan konumu yüklendi",
          locationData
        );
      }
    }

    setSelectedLocation(locationData);
    setIsLoadingLocation(false);
  }, []); // Sadece ilk render'da çalışır

  // Konumu güncelleme fonksiyonu (state'i ve localStorage'ı günceller)
  const updateSelectedLocation = useCallback((newLocationData) => {
    // newLocationData'nın beklenen yapıda olduğundan emin ol
    if (
      newLocationData &&
      newLocationData.cityId &&
      newLocationData.districtId
    ) {
      console.log("LocationContext: Konum güncelleniyor", newLocationData);
      setSelectedLocation(newLocationData);
      localStorage.setItem("selectedLocation", JSON.stringify(newLocationData));
    } else {
      console.warn(
        "LocationContext: Geçersiz konum verisiyle güncelleme denendi",
        newLocationData
      );
    }
  }, []);

  // Çıkış yapıldığında konumu temizle
  const clearSelectedLocation = useCallback(() => {
    console.log("LocationContext: Konum temizleniyor.");
    setSelectedLocation(null);
    localStorage.removeItem("selectedLocation");
  }, []);

  return (
    <LocationContext.Provider
      value={{
        selectedLocation,
        updateSelectedLocation,
        isLoadingLocation,
        clearSelectedLocation,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

// Hook oluştur (kolay kullanım için)
export const useSelectedLocation = () => {
  const context = useContext(LocationContext);
  if (context === undefined) {
    throw new Error(
      "useSelectedLocation must be used within a LocationProvider"
    );
  }
  return context;
};
